import { render, staticRenderFns } from "./invitados_no_confirmados2.vue?vue&type=template&id=45e3a394&scoped=true"
import script from "./invitados_no_confirmados2.vue?vue&type=script&lang=js"
export * from "./invitados_no_confirmados2.vue?vue&type=script&lang=js"
import style0 from "./invitados_no_confirmados2.vue?vue&type=style&index=0&id=45e3a394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3a394",
  null
  
)

export default component.exports